import {
  axiosGetWithCookies,
  axiosGetWithCookiesCancel,
  axiosPutWithCookies,
} from './helper';
import { startOfDay, endOfDay } from '../utils/time';
import { PAGE_NAME } from '../utils/constants';

export const fetchTaskList = ({
  from,
  limit = 50,
  search,
  sort,
  status,
  taskType,
  isTemplate,
  archived = false,
  location,
  site,
  businessClient,
  dateFrom,
  dateTo,
  timezone,
  assetId,
  taskCategory,
  departmentId,
}) => {
  let query = `/tasks/tasks/overview?limit=${limit}`;
  if (location === PAGE_NAME.REPORTING) {
    query = `/tasks/tasks/reporting?limit=${limit}`;
  }
  if (Array.isArray(taskCategory)) {
    /* eslint-disable no-param-reassign */
    query += taskCategory.reduce(
      (acc, c) =>
        (acc += c.id ? `&taskCategory=${c.id}` : `&taskCategory=${c}`),
      '',
    );
  } else if (taskCategory) {
    // it is a string
    query += `&taskCategory=${taskCategory}`;
  }
  // status is always an array of objects with id and name
  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }
  if (Array.isArray(assetId)) {
    //it comes from async select with multiple objects in an array
    /* eslint-disable no-param-reassign */
    query += assetId.reduce((acc, c) => (acc += `&assetId=${c.id}`), '');
  } else if (typeof assetId === 'object') {
    // it comes from async select with a single object
    query += `&assetId=${assetId.id}`;
  }

  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  if (sort) query += `&sort=${sort}`;
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (typeof isTemplate !== 'undefined') query += `&isTemplate=${isTemplate}`;

  if (site && typeof site === 'object') {
    query += `&siteId=${site.id}`;
  } else if (typeof site === 'string') {
    query += `&siteId=${site}`;
  }

  if (businessClient && typeof businessClient === 'object') {
    query += `&businessClientId=${businessClient.id}`;
  } else if (typeof businessClient === 'string') {
    query += `&businessClientId=${businessClient}`;
  }

  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timeZone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (Array.isArray(taskType)) {
    /* eslint-disable no-param-reassign */
    query += taskType.reduce((acc, c) => (acc += `&taskType=${c.name}`), '');
  }
  if (archived) query += `&includeArchived=${archived}`;
  return axiosGetWithCookies(query);
};

export const fetchTaskTemplates = ({
  from,
  limit = 50,
  search,
  sort,
  status,
  // taskType,
  isTemplate,
  archived = false,
  site,
  businessClient,
  assetId,
  taskCategory,
  departmentId,
}) => {
  let query = `/tasks/tasks/templates?limit=${limit}`;
  if (Array.isArray(assetId)) {
    //it comes from async select with multiple objects in an array
    /* eslint-disable no-param-reassign */
    query += assetId.reduce((acc, c) => (acc += `&assetId=${c.id}`), '');
  } else if (typeof assetId === 'object') {
    // it comes from async select with a single object
    query += `&assetId=${assetId?.id}`;
  }
  if (Array.isArray(taskCategory)) {
    /* eslint-disable no-param-reassign */
    query += taskCategory.reduce(
      (acc, c) =>
        (acc += c?.id ? `&taskCategory=${c.id}` : `&taskCategory=${c}`),
      '',
    );
  } else if (taskCategory) {
    // it is a string
    query += `&taskCategory=${taskCategory}`;
  }
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  if (sort) query += `&sort=${sort}`;
  if (site) query += `&siteId=${site}`;
  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }
  // query += Array.isArray(taskType)
  //   ? taskType.reduce((acc, c) => (acc += `&taskType=${c.id}`), '')
  //   : `&taskType=${taskType}`;
  if (typeof isTemplate !== 'undefined') query += `&isTemplate=${isTemplate}`;
  if (archived) query += `&includeArchived=${archived}`;
  return axiosGetWithCookies(query);
};

export const fetchCancellableTaskList = ({
  from,
  limit = 50,
  search,
  sort,
  status,
  taskType,
  departmentId,
}) => {
  let query = `/tasks/tasks/overview?limit=${limit}`;
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  if (sort) query += `&sort=${sort}`;
  if (status) query += `&status=${status}`;
  if (taskType) query += `&taskType=${taskType}`;
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  return axiosGetWithCookiesCancel(query);
};

export const fetchTaskDetails = ({ id }) => {
  return axiosGetWithCookies(`/tasks/tasks/${id}`);
};

export const getTaskQr = id => axiosGetWithCookies(`/tasks/tasks/${id}/qr-pdf`);

export const fetchCleanerTaskListPdf = ({
  dateFrom,
  dateTo,
  businessClient,
  search,
  timezone,
  site,
  status,
  limit = 50,
  language,
  assetId,
  departmentId,
  taskCategory,
  taskType,
}) => {
  let query = `/tasks/tasks/reporting/pdf?&limit=${limit}`;
  if (Array.isArray(assetId)) {
    //it comes from async select with multiple objects in an array
    /* eslint-disable no-param-reassign */
    query += assetId.reduce((acc, c) => (acc += `&assetId=${c.id}`), '');
  } else if (typeof assetId === 'object') {
    // it comes from async select with a single object
    query += `&assetId=${assetId.id}`;
  }
  if (Array.isArray(taskCategory)) {
    /* eslint-disable no-param-reassign */
    query += taskCategory.reduce(
      (acc, c) =>
        (acc += c?.id ? `&taskCategory=${c.id}` : `&taskCategory=${c}`),
      '',
    );
  } else if (taskCategory) {
    // it is a string
    query += `&taskCategory=${taskCategory}`;
  }
  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timeZone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }
  if (Array.isArray(taskType)) {
    /* eslint-disable no-param-reassign */
    query += taskType.reduce((acc, c) => (acc += `&taskType=${c.name}`), '');
  }
  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (site) query += `&siteId=${site}`;
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (timezone) query += `&timezone=${timezone || 'UTC'}`;
  if (search) query += `&search=${search}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};

export const fetchCleanerTaskDetailsPdf = ({ id, timezone, language }) => {
  let query = `/tasks/tasks/${id}/pdf`;
  if (timezone) query += `?timezone=${timezone}`;
  if (language) query += `&language=${language}`;
  return axiosGetWithCookies(query);
};

export const taskUpload = ({ data }) => {
  return axiosPutWithCookies(`/tasks/tasks`, { data });
};

export const putTaskSchedule = ({ data, id }) => {
  return axiosPutWithCookies(`/tasks/tasks/${id}/schedules`, { data });
};

export const fetchTaskSchedule = ({ id }) => {
  return axiosGetWithCookies(`/tasks/tasks/${id}/schedules`);
};

export const fetchTaskTypes = ({
  from,
  limit = 50,
  search,
  qualificationRequired = false,
  sort,
  taskCategory,
  archived = false,
  departmentId,
  location,
  systemOnly = true,
}) => {
  let query = `/tasks/tasks/types?limit=${limit}`;
  if (location === PAGE_NAME.REPORTING) {
    query = `/tasks/tasks/reporting?limit=${limit}`;
  }

  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (!systemOnly) {
    query += `&systemOnly=${systemOnly}`;
  }

  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  if (sort) query += `&sort=${sort}`;
  if (Array.isArray(taskCategory)) {
    /* eslint-disable no-param-reassign */
    query += taskCategory.reduce(
      (acc, c) =>
        (acc += c?.id ? `&taskCategory=${c.id}` : `&taskCategory=${c}`),
      '',
    );
  } else if (taskCategory) {
    // it is a string
    query += `&taskCategory=${taskCategory}`;
  }
  if (qualificationRequired)
    query += `&qualificationRequired=${qualificationRequired}`;

  if (archived) query += `&includeArchived=${archived}`;
  return axiosGetWithCookies(query);
};
/**
 * Create and Update are both Puts and the Platform will choose if it is an update or not.
 // eslint-disable-next-line valid-jsdoc
 * @param {Object} data the data defined in the structure of the API.
 * @returns {Promise<AxiosResponse<any>>} the status and restful data.
 */
export const updateTaskType = data => {
  return axiosPutWithCookies(`/tasks/tasks/types`, data);
};
